module.exports = __webpack_public_path__ + "img/review_active.208430c4.png";